import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { trafficSources } from "actions"
import Title from 'containers/general/title'
import { Route, Link } from 'react-router-dom'

class ThankYou extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="sale">
                <Title title="Thank You" showDate={false} />
                <div className="content">
                    <p>Entry has been successfully saved.</p>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ThankYou)